import React, { Component } from "react"

import { Link } from "react-router-dom"
import NFTCheck from "../Components/NFTCheck"

class ValidateNFT extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <NFTCheck />
                </div>
            </React.Fragment>
        )
    }
}

export default ValidateNFT
